module.exports = __webpack_public_path__ + "img/chatgpt.364472d9.svg";